export const mutations = {
  SET_SELECTED_TEMPLATE (state, data) {
    state.selectedTemplate = data
  },
  SET_ACTIVE_VIEW (state, name) {
    state.activeView = name
  },
  SET_TEMPLATES (state, templates) {
    state.templates = templates
  },
  SET_GLOBAL_TEMPLATES (state, templates) {
    state.globalTemplates = templates
  },
  SET_GLOBAL_PAGING (state, paging) {
    state.globalPaging = { ...state.globalPaging, ...paging }
  },
  SET_GLOBAL_COMPANY_PERMISSION (state, permission) {
    state.globalCompanyPermission = permission
  },
  SET_USER_COMPANY_PERMISSION (state, permission) {
    state.globalUserPermission = permission
  },
  SET_PAGING (state, paging) {
    state.paging = { ...state.paging, ...paging }
  },
  SET_TEMPLATE_SUMMARY (state, summary) {
    state.template.summary = summary
  },
  SET_TEMPLATE_CAMPAIGNS (state, campaigns) {
    state.template.campaigns = campaigns
  },
  SET_TEMPLATE_HISTORY (state, history) {
    state.template.history = history
  },
  SET_TEMPLATE_HISTORY_ITEM_OPENED (state, { templateHistoryId, opened }) {
    const i = state.template.history.findIndex(h => h.id === templateHistoryId)
    if (i > -1) {
      state.template.history[i].hasBeenOpened = true
      state.template.history[i].opened = opened
    }
  },
  SET_TEMPLATE_HISTORY_ITEM_PREVIEW_CONTENT (state, { templateHistoryId, previewContent }) {
    const i = state.template.history.findIndex(h => h === templateHistoryId)
    if (i > -1) {
      state.template.history[i].previewContent = previewContent
    }
  },
  SET_TEMPLATE_HISTORY_ITEM_REVERSION (state, templateVersionId) {
    let i = state.template.history.findIndex(h => h.templateVersionId === templateVersionId)
    if (i > -1) {
      for (i; i < state.template.history.length; i++) {
        state.template.history[i].reverted = true
        state.template.history[i].canRevert = false
      }
    }
  },
  RESET_TEMPLATE (state) {
    state.template = {
      summary: {},
      campaigns: [],
      history: [],
      basicValidation: []
    }
  },
  SET_TEMPLATE_SELECTED_FOR_PREVIEW (state, templateSelectedForPreview) {
    state.templateSelectedForPreview = templateSelectedForPreview
  },
  SET_TEMPLATE_PREVIEW_CONTENT (state, templatePreviewContent) {
    state.templatePreviewContent = templatePreviewContent
  },
  SET_GRIDSELECTEDTEMPLATE (state, template) {
    state.gridSelectedTemplate = template
  },
  SET_EXTERNALID (state, externalId) {
    state.externalId = externalId
  },
  SET_CLIENTID (state, clientId) {
    state.clientId = clientId
  },
  SET_ENV_NAME (state, env) {
    state.environmentName = env
  },
  SET_ACCOUNT (state, account) {
    state.account = account
  },
  SET_ACCOUNTID (state, accountId) {
    state.accountId = accountId
  },
  SET_EGALLERY_UID (state, eGalleryUid) {
    state.eGalleryUid = eGalleryUid
  },
  SET_ALL_ACCOUNTS (state, allAccounts) {
    state.allAccounts = allAccounts
  },
  SET_ALLOWED_ACCOUNTS (state, allowedAccounts) {
    state.allowedAccounts = allowedAccounts
  },
  SET_AVAILABLE_ACCOUNTS (state, availableAccounts) {
    state.availableAccounts = availableAccounts
  },
  SET_EINSIGHT_URI (state, einsightUri) {
    state.einsightUri = einsightUri
  },
  SET_APP_CONFIG (state, appConfig) {
    state.appConfig = appConfig
    if (appConfig.customizationConfig) {
      state.grapesJSConfig.customizationConfig = appConfig.customizationConfig
    }
  },
  SET_LOADING (state, { name, status }) {
    const newLoadingStatus = { ...state.loadingStatus }
    newLoadingStatus[name] = status
    state.loadingStatus = newLoadingStatus
  },
  SET_LOADING_CUSTOMERS (state, loading) {
    state.loadingCustomers = loading
  },
  SET_LOCALE (state, locale) {
    state.locale = locale
  },
  SET_DATE_FORMAT (state, dateFormat) {
    state.dateFormat = dateFormat
  },
  SET_TIME_FORMAT (state, timeFormat) {
    state.timeFormat = timeFormat
  },
  SET_USER_EMAIL (state, userEmail) {
    state.userEmail = userEmail
  },
  SET_GRID_LOADED (state, gridLoaded) {
    state.gridLoaded = gridLoaded
  },
  SET_USER_ACCESS_CONTROL (state, accessControl) {
    state.userAccessControl = accessControl
  },
  SET_TRANSACTIONAL_TEST_MODE (state, transactionalMailingInTestMode) {
    state.transactionalMailingInTestMode = transactionalMailingInTestMode
  },
  SET_HAS_EMAIL_CONTENT_APPROVAL (state, hasEmailContentApproval) {
    state.hasEmailContentApproval = hasEmailContentApproval
  },
  SET_LANDING_TAB (state, landingTab) {
    state.landingTab = landingTab
  },
  SET_BASIC_VALIDATION (state, basicValidation) {
    state.template.basicValidation = basicValidation
  },
  SET_VALIDATION_TEMPLATE_ID (state, templateId) {
    state.validationTemplateId = templateId
  },
  SET_GRAPES_JS_INSTANCE (state, instance) {
    state.grapesJSInstance = instance
  },
  SET_DYNAMIC_CONTENT_MODAL_REF (state, ref) {
    state.dynamicContent.modalRef = ref
  },
  SET_DYNAMIC_CONTENT_MODAL_OPEN (state, isOpen) {
    state.dynamicContent.isModalOpen = isOpen
  },
  SET_DYNAMIC_CONTENT_SELECTED_TAB (state, selectedTab) {
    state.dynamicContent.selectedTab = selectedTab
  },
  SET_TAGS_SECTIONS (state, sections) {
    state.dynamicContent.tagsSections = sections
  },
  SET_PERSONALIZATION_TAGS (state, tags) {
    state.dynamicContent.personalizationTags = tags
  },
  SET_ADD_ONS (state, addOns) {
    state.dynamicContent.addOns = addOns
  },
  SET_CUSTOM_LINKS (state, customLinks) {
    state.dynamicContent.customLinks = customLinks
  },
  SET_GLOBAL_LINKS (state, globalLinks) {
    state.dynamicContent.globalLinks = globalLinks
  },
  SET_GLOBAL_LINK_ON_EDITION (state, globalLinkOnEdition) {
    state.dynamicContent.globalLinkOnEdition = globalLinkOnEdition
  },
  SET_TAGGED_LINKS (state, taggedLinks) {
    state.dynamicContent.taggedLinks = taggedLinks
  },
  SET_ALL_LINKS (state, allLinks) {
    state.dynamicContent.allLinks = allLinks
  },
  SET_TEMPLATE_ON_EDITION (state, template) {
    state.templateOnEdition = template
  },
  UPDATE_TEMPLATE (state, template) {
    state.templateOnEdition = template
  },
  SET_EDITORS_TYPES (state, editorsTypes) {
    state.editorsTypes = editorsTypes
  },
  SET_TAGS (state, tags) {
    state.tags = tags
  },
  SET_GRID_STATE_CHANGE_DATA (state, where) {
    state.gridStateChangeData = where
  },
  SET_USERS (state, users) {
    state.users = users
  },
  SET_TEMPLATE_ON_PREVIEW (state, templatePreviewContent) {
    state.templatePreviewContent = templatePreviewContent
  },
  SET_EMAIL_TESTING (state, emailTesting) {
    state.emailTesting = {
      ...state.emailTesting,
      ...emailTesting
    }
  },
  SET_EMAIL_TESTING_ON_EDITION (state, emailTestingOnEdition) {
    state.emailTesting = {
      ...state.emailTesting,
      emailTestingOnEdition
    }
  },
  SET_EMAIL_TESTING_HAS_DIALOG_CLOSE (state, hasDialogClose) {
    state.emailTesting.hasDialogClose = hasDialogClose
  },
  SET_SEND_TEST_MODAL_IS_OPEN (state, isOpen) {
    state.emailTesting.sendTestModalIsOpen = isOpen
  },
  SET_SEND_EMAIL_TESTING_EDITING_MODAL_IS_OPEN (state, isOpen) {
    state.emailTesting.editingModalIsOpen = isOpen
  },
  SET_SEARCHING_TEMPLATE (state, isActive) {
    state.isSearchingTemplate = isActive
  },
  SET_CREATING_CAMPAIGN_TEMPLATE (state, isActive) {
    state.isCreatingCampaign = isActive
  },
  SET_CUSTOM_LINKS_HOST (state, host) {
    state.customLinksHost = host
  },
  SET_CAN_CREATE_TEMPLATE (state, canCreateTemplate) {
    state.accessSettings.canCreateTemplate = canCreateTemplate
  },
  SET_ACTIVE_TYPE (state, name) {
    state.activeType = name
  },
  SET_SAVED_GRID_EDITOR_FILTER (state, filterArray) {
    state.savedGridEditorFilter = filterArray
  },
  SET_PREBUILT_GRID_EDITOR_FILTER (state, filterArray) {
    state.prebuiltGridEditorFilter = filterArray
  },
  SET_STUDIO_EDITOR_CREATE_PERMISSION (state, permission) {
    state.studioEditorCreatePermission = permission
  },
  SET_DRAG_DROP_CREATE_PERMISSION (state, permission) {
    state.dragAndDropCreatePermission = permission
  },
  SET_CUSTOM_CODE_CREATE_PERMISSION (state, permission) {
    state.customCodeCreatePermission = permission
  }
}
